import React from 'react';
import NextApp from 'next/app';
import Router from 'next/router';
import '@spotify-internal/encore-web/css/encore-light-theme.css';
import { GlobalStyles } from '@spotify-internal/encore-web';
import { BrowserMetrics, WebVital } from '@spotify-internal/semantic-metrics';

import { sendMetric, withRouteMetrics } from '../next/helpers/semanticMetrics';

import '@spotify-internal/encore-web/css/fonts.css';
import '../next/style/marketing-global.css';

class CustomApp extends NextApp {
  render() {
    const { Component, pageProps } = this.props;
    return (
      <>
        <GlobalStyles />
        <Component {...pageProps} />
      </>
    );
  }
}

export function reportWebVitals(metric: WebVital) {
  sendMetric(
    BrowserMetrics.getWebVitalsMetric(metric, {
      route: Router.router?.route ?? 'unknown',
    }),
  );
}

const appWithRouteMetrics: ReturnType<typeof withRouteMetrics> =
  withRouteMetrics(CustomApp);
export default appWithRouteMetrics;
